import { combineReducers } from '@reduxjs/toolkit';

import superAdminAuth from './SuperAdminAuth.Reducer';
import companyAuth from './CompanyAuth.Reducer';
import appUi from './Ui.Reducer';

const Reducers = combineReducers({
   superAdminAuth,
   companyAuth,
   appUi,
});

export default Reducers;
